import { appEvents } from "@cayo/shared/components/App/appEvents";
import { IShowControlHandler } from "@cayo/shared/components/App/types";
import { IActionHandlerParams } from "../types";

export const showClientComponent = (expression: string, parameters: IActionHandlerParams) => {
  const params = expression.split(",");

  const parts = params[0].split("/");
  const folder = parts[0];
  const controlId = parts[1];
  const showControlHandler: IShowControlHandler = { controlId, folder, parameters };
  if (params.length > 1) {
    (showControlHandler as any)[params[1]] = true;
  }

  appEvents.trigger({
    showControl: showControlHandler,
  });
};
